// extracted by mini-css-extract-plugin
export default {"menu":"Staff_menu__jLcEB","nav":"Staff_nav__trpbY"};